<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m48 20a34.08 34.08 0 1 1 -34.08 34.09 34.12 34.12 0 0 1 34.08-34.09m0-4a38.08 38.08 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09z"
      fill="#4f2b1b"
    />
    <circle
      cx="48.03"
      cy="54.14"
      fill="#85c441"
      r="20.11"
    />
    <ellipse
      cx="48.61"
      cy="52.42"
      fill="#fff"
      rx="9.19"
      ry="12.64"
    />
    <g fill="#4f2b1b">
      <path
        d="m48.22 47c-3.32 0-6 .12-6 3.64a4.64 4.64 0 0 0 1 2.81 8.54 8.54 0 0 1 5.21-1.94 7.89 7.89 0 0 1 5 1.87 5.18 5.18 0 0 0 .82-2.74c-.03-3.53-2.72-3.64-6.03-3.64zm-2.94 4.36a1.5 1.5 0 1 1 1.5-1.49 1.49 1.49 0 0 1 -1.5 1.48zm5.95 0a1.54 1.54 0 1 1 1.55-1.54 1.54 1.54 0 0 1 -1.55 1.53z"
      />
      <path d="m47.88 54.33s-1.46-.58-1.33-1.29 1.13 0 1.26.47.31.82.07.82z" />
      <path d="m48.77 54.33s1.28-.58 1.16-1.29-1 0-1.1.47-.27.82-.06.82z" />
      <path
        d="m48.72 61.28c-4-.07-5.17-1.65-5.53-2-.13-.1-.22-.22-.14-.36a.36.36 0 0 1 .44-.11s5.55 3 9.87-.3a.33.33 0 0 1 .44.1c.09.12 0 .22-.12.36-1.22 1.92-3.88 2.33-4.96 2.31z"
      />
      <path d="m46 49.36a.76.76 0 0 1 -.76.76.76.76 0 1 1 .76-.76z" />
      <path d="m52 49.32a.77.77 0 0 1 -.78.77.76.76 0 0 1 -.77-.77.77.77 0 0 1 .77-.78.78.78 0 0 1 .78.78z" />
      <path
        d="m48.07 74.85a20.77 20.77 0 1 1 20.77-20.76 20.79 20.79 0 0 1 -20.77 20.76zm0-40.36a19.6 19.6 0 1 0 19.6 19.6 19.62 19.62 0 0 0 -19.6-19.6z"
      />
      <path
        d="m65.82 58.18a22.44 22.44 0 0 1 -4.82-5.37c-.3-.48-1.79-3-2-3.55a11.41 11.41 0 0 1 1.39.71c.21-2.63-2.78-6.67-2.78-6.67s.58-.11 1.16-.28c-2.91-5.14-7-6.18-9.39-6.19a11.83 11.83 0 0 0 -8.62 2.75 14.66 14.66 0 0 0 -4.87 9.56 4.65 4.65 0 0 1 1.3-.44 7.6 7.6 0 0 1 -3 6.48 28 28 0 0 0 -5 5.27 20.19 20.19 0 0 0 38.45.09 9.38 9.38 0 0 0 -1.82-2.36zm-17.6 5.08c-4.09 0-7.4-3.32-7.4-5.89a6.1 6.1 0 0 1 1.89-3.84 7.33 7.33 0 0 1 -1.41-3.93c0-3.8 3.1-8.44 6.92-8.44s6.92 4.64 6.92 8.44a7.87 7.87 0 0 1 -1.26 3.91 6.28 6.28 0 0 1 1.74 3.86c0 2.57-3.31 5.89-7.4 5.89z"
      />
      <path
        d="m35 34.88-.74-1.38.41-.22-2.71-5.07-.41.22-.78-1.43 2.5-1.34c1.19-.64 2.13-.3 2.83 1l.47.89c.71 1.31.56 2.24-.45 2.78l-.82.44.89 1.64.4-.21.74 1.38zm-.38-5.4.24-.13c.27-.15.41-.29.43-.44a1.34 1.34 0 0 0 -.29-.71l-.34-.65q-.23-.42-.45-.48a1.1 1.1 0 0 0 -.65.18l-.14.08z"
      />
      <path
        d="m39.11 32.6-.42-1.51.31-.09-.34-5.87-.53.15-.42-1.53 3.42-.94.42 1.52-.5.14 2.69 5.22.34-.1.42 1.51-2.5.68-.42-1.5.52-.15-.39-.84-1.37.38.09.92.5-.14.46 1.55zm1.16-4.12 1-.27-1.27-2.89z"
      />
      <path d="m45 31.08v-1.57h.46l-.14-5.75h-.46v-1.58l2.67-.07v1.58h-.46l.15 5.81h1.24v-1.54h1.37l.01 3.04z" />
      <path
        d="m52.49 22.24 2.52.63-.12 3.79 1.76-3.38 2.44.62-.38 1.53-.45-.11-1.39 5.58.44.11-.38 1.52-2.35-.59.42-1.52.36.09 1.45-5.31-2.55 4.8-.61-.16.19-5.4-1.34 5.36.37.09-.38 1.52-2.16-.54.38-1.52.45.11 1.4-5.57-.45-.12z"
      />
      <path
        d="m67 31.43-2.29 3.18q-1.55 2.16-3.32.88c-1.18-.84-1.25-2-.22-3.43l2.29-3.17q1.54-2.16 3.31-.89c1.17.85 1.23 2 .23 3.43zm-1.31-1.16q.45-.61.09-.87c-.23-.17-.5 0-.79.36l-2.5 3.47c-.29.41-.33.7-.09.87s.5 0 .79-.36z"
      />
      <path
        d="m63.79 37.2 1.13-1.09.32.34 4.16-4-.32-.33 1.15-1.09 1.84 1.97-1.14 1.09-.32-.33-4.16 4 .31.33-1.13 1.08z"
      />
      <path
        d="m66.11 39.59 1.32-.85.25.39 4.83-3.13-.25-.39 1.33-.85 1.41 2.24-1.33.86-.25-.39-4.88 3.15.67 1 1.3-.83.78 1.21-2.56 1.65z"
      />
      <path
        d="m69.93 46.48 1.52-.36.11.45 5.6-1.31-.11-.45 1.54-.36 1.11 4.77-2.61.61-.31-1.33 1.14-.27-.3-1.23-1.85.44.23 1.08-1.68.39-.26-1.13-2.13.5.1.45-1.53.35z"
      />
      <path
        d="m71.12 51.71h1.57v.45l5.75.1v-.46h1.58v2.72a2.75 2.75 0 0 1 -.47 1.76 2 2 0 0 1 -1.59.51h-.56a2.11 2.11 0 0 1 -1.27-.35 1.18 1.18 0 0 1 -.41-1 1.94 1.94 0 0 1 -.49 1 1.42 1.42 0 0 1 -1 .29h-1.56v.45h-1.57v-2.14l3 .05a.93.93 0 0 0 .72-.21 1.2 1.2 0 0 0 .21-.8v-.08h-2.36v.38h-1.56zm5.34 2.29v.44a.57.57 0 0 0 .68.69h.65a.65.65 0 0 0 .54-.18 1.27 1.27 0 0 0 .14-.69v-.26z"
      />
      <path
        d="m71 57.58 1.51.39-.12.45 5.56 1.47.12-.45 1.53.41-1.25 4.73-2.57-.68.35-1.32 1.1.29.34-1.27-1.84-.49-.3 1.13-1.66-.44.23-1.13-2.16-.57-.34 1.27 1.34.36-.35 1.32-2.8-.74z"
      />
      <path
        d="m69.46 63 1.37.75-.22.4 5 2.76.22-.4 1.39.76-2.35 4.29-2.34-1.27.71-1.29 1 .55.63-1.15-1.66-.91-.56 1-1.51-.83.55-1-2-1.08-.63 1.16 1.21.66-.66 1.2-2.54-1.39z"
      />
      <path
        d="m68 72.89a1 1 0 0 1 .32.63.7.7 0 0 1 -.2.61.72.72 0 0 1 -.6.21 1 1 0 0 1 -.64-.32 1.06 1.06 0 0 1 -.32-.64.71.71 0 0 1 .8-.8 1 1 0 0 1 .64.31z"
      />
      <path
        d="m61.43 73 .77 1.36-.4.23 2.82 5 .4-.23.78 1.38-2.48 1.39c-1.17.66-2.12.35-2.84-.94l-.5-.88c-.73-1.3-.6-2.23.4-2.8l.8-.45-.91-1.62-.4.22-.77-1.36zm.5 5.39-.24.13q-.39.22-.42.45a1.49 1.49 0 0 0 .25.71l.36.64c.16.28.31.43.46.46a1 1 0 0 0 .64-.19l.14-.08z"
      />
      <path
        d="m57.29 75.41.44 1.5-.33.1.45 5.87.52-.16.45 1.51-3.4 1-.42-1.5.49-.14-2.78-5.18-.34.1-.47-1.51 2.48-.73.44 1.5-.51.15.39.83 1.37-.4-.1-.92-.51.15-.46-1.49zm-1.09 4.13-1 .3 1.36 2.86z"
      />
      <path
        d="m51.41 77 .07 1.56h-.45l.25 5.75h.46l.07 1.58-2.67.11-.07-1.57h.46l-.26-5.8-1.27.07.07 1.54-1.37.06-.13-3z"
      />
      <path
        d="m44.1 86-2.52-.59.05-3.78-1.7 3.41-2.46-.57.36-1.54.45.1 1.29-5.6-.45-.11.35-1.52 2.36.54-.35 1.53-.36-.08-1.34 5.34 2.41-4.86.62.15-.09 5.4 1.28-5.37-.37-.08.35-1.53 2.16.5-.35 1.52-.45-.1-1.34 5.61.45.1z"
      />
      <path
        d="m29.43 77.08 2.23-3.22c1-1.46 2.12-1.77 3.31-.94s1.29 2 .28 3.43l-2.25 3.21q-1.53 2.19-3.31 1t-.26-3.48zm1.33 1.14c-.29.42-.31.71-.07.87s.5 0 .78-.38l2.44-3.51c.29-.42.31-.7.08-.87s-.51 0-.79.38z"
      />
      <path
        d="m32.52 71.26-1.11 1.1-.32-.36-4.1 4 .33.32-1.13 1.11-1.88-1.9 1.13-1.11.32.33 4.09-4-.32-.33 1.11-1.1z"
      />
      <path
        d="m30.15 68.91-1.3.87-.26-.38-4.77 3.21.25.38-1.31.88-1.49-2.22 1.31-.88.26.38 4.82-3.23-.69-1-1.28.86-.76-1.14 2.53-1.7z"
      />
      <path
        d="m26.22 62.1-1.52.39-.11-.49-5.59 1.46.12.44-1.53.39-1.21-4.75 2.6-.66.34 1.33-1.14.29.33 1.27 1.84-.47-.28-1.12 1.67-.42.26 1.12 2.12-.54-.12-.44 1.52-.39z"
      />
      <path
        d="m25 56.91h-1.56v-.46l-5.75.09v.46h-1.58l-.11-2.67a2.78 2.78 0 0 1 .42-1.77 2 2 0 0 1 1.58-.56h.56a2.1 2.1 0 0 1 1.27.3 1.2 1.2 0 0 1 .45 1 1.94 1.94 0 0 1 .45-1 1.38 1.38 0 0 1 1-.32h1.56v-.45h1.56v2.13l-3 .05a1 1 0 0 0 -.72.23 1.2 1.2 0 0 0 -.18.8v.1h2.36v-.38h1.56zm-5.41-2.12v-.44a.81.81 0 0 0 -.16-.53.73.73 0 0 0 -.54-.14h-.69a.65.65 0 0 0 -.54.2 1.3 1.3 0 0 0 -.12.69v.24z"
      />
      <path
        d="m25 51-1.52-.37.11-.45-5.59-1.33-.11.44-1.53-.37 1.16-4.76 2.59.63-.33 1.33-1.11-.27-.31 1.28 1.85.45.27-1.13 1.67.41-.29 1.14 2.18.53.31-1.28-1.35-.34.32-1.33 2.81.69z"
      />
      <path
        d="m26.38 45.61-1.38-.72.22-.41-5.1-2.67-.21.41-1.4-.73 2.27-4.34 2.36 1.23-.63 1.21-1-.53-.61 1.17 1.68.88.54-1 1.53.8-.54 1 2 1 .61-1.17-1.23-.64.64-1.21 2.56 1.34z"
      />
      <path
        d="m27.56 35.71a1 1 0 0 1 -.32-.63.71.71 0 0 1 .18-.61.75.75 0 0 1 .59-.22 1.07 1.07 0 0 1 .66.31 1 1 0 0 1 .32.63.72.72 0 0 1 -.18.61.73.73 0 0 1 -.6.2 1 1 0 0 1 -.65-.29z"
      />
    </g>
  </svg>
</template>
